import type { FetchOptions } from './types'
import Request from '.'
import { reportSGM } from '@jdt-jinke/jdpay_utils'

/*********** 初始化非加密网关实例 start ****************/
console.log('查询金融网关接口配置：')

// 实例化fetch方法
const fetch = new Request({})

// 设置网关配置
fetch.setGW({ transformRequest, transformResponse })

/** 导出请求方法 */
export const Network = fetch
/******* end ********/

/** 科技网关响应数据结构 */
interface JDTResponse {
  // 响应码 0: 成功
  resultCode: number
  // 是否加密
  channelEncrypt: number
  // 业务数据
  resultData: Record<string, any>
  // 响应结果描述
  resultMsg: string
  // 请求是否成功
  success: boolean
}

/** 入参转化 */
async function transformRequest(params: object) {
  const reqData = JSON.stringify(params)
  const cco = await signParams(params)
  return { reqData, cco, eidToken: window.eidToken || '' }
}

/** 响应转化 **/
function transformResponse(res: JDTResponse, options: FetchOptions) {
  console.log('------转化数据-----：', res, options)
  try {
    const {
      resultCode: code,
      resultMsg: message,
      channelEncrypt: encypt,
      resultData: data
    } = res || {}

    if (typeof data === 'object') {
      data.url = options.url
      data.params = options.params
    }

    return { ...res, code, message, encypt, data, options }
  } catch (err) {
    reportSGM({
      code: 'transformResponse_error',
      type: 1,
      res: { res, options },
      err
    })
    return res
  }
}

/*********************************************************************************
 * 科技网关对参数加签 TODO:
 * https://joyspace.jd.com/pages/4ZXkAGsUxZaU5oJkhorF
 * @param {} data 接口请求入参
 * @param {*} appId wapp 运营平台申请的业务ID
 */
export async function signParams(data: object, appId?: string) {
  const signData = {
    clientVersion: '1.0.0',
    client: 'h5',
    t: Date.now(),
    h5st: null,
    _stk: null
  }

  try {
    // 获取加签构造函数，兼容低防护和高防护
    const ParamsSign = window.ParamsSign || window.ParamsSignLite
    // 如果有加签构造函数，就对参数进行加签处理
    if (typeof ParamsSign?.prototype === 'function') {
      // 实例化加签方法
      const signInstance = new ParamsSign({ appId, preRequest: true })
      // 将 data 的obj或array 属性转化成字符串
      stringfyObjKey(data)
      // 执行加签
      const signedParams = await signInstance.sign(data).catch(console.log)
      // @ts-ignore 修改默认的加签参数
      signData.h5st = signedParams.h5st ? encodeURI(signedParams.h5st) : null
      // @ts-ignore 修改默认的加签参数
      signData._stk = Object.keys(data).join(',')
    }
  } catch (error) {
    // sgmReporter('allowance_signParams_error', { data, error })
  }
  // 返回加签结果
  return JSON.stringify(signData)
}

/** 将对象的obj|array属性转化成字符串
 * @param {object} data
 */
function stringfyObjKey(data: any) {
  for (const prop in data) {
    const type = Object.prototype.toString.call(data[prop])
    if (type === '[object Object]' || type === '[object Array]') {
      data[prop] = JSON.stringify(data[prop])
    }
  }
}
